// @ts-check
import * as sentry from "./sentry"

export const title = "__PROJECT_TITLE__"

let _apiBaseURL = typeof window !== "undefined" && window.localStorage?.getItem("apiBase")

export const apiBaseURL = _apiBaseURL || "/api/"
//export const sentryDSN = "https://95fad64e48484bd7b3e52e56416ac38e@sentry.basehosts.de/2"
export const sentryDSN = ""
export const sentryTracingOrigins = [
    "localhost",
    apiBaseURL,
    // more api trace urls here
    /^\//,
]
export const sentryEnvironment = "master"

// need to execute early for fetch wrapping
// will be uncommented via drone CI
// sentry.init(sentryDSN, sentryTracingOrigins, sentryEnvironment)
